<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.recommended-parts.critical-parts' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.CriticalParts"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="number"
                  step="1"
                  min="0"
                  name="CriticalParts"
                  class="ir-form-set"
                  formControlName="CriticalParts"
                  placeholder="{{ 'plugins.recommended-parts.parts-placeholder' | translate }}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.recommended-parts.damaged-parts' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.DamagedParts"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="number"
                  step="1"
                  min="0"
                  name="DamagedParts"
                  class="ir-form-set"
                  formControlName="DamagedParts"
                  placeholder="{{ 'plugins.recommended-parts.parts-placeholder' | translate }}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'plugins.recommended-parts.worn-parts' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.WornParts"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="number"
                  step="1"
                  min="0"
                  name="WornParts"
                  class="ir-form-set"
                  formControlName="WornParts"
                  placeholder="{{ 'plugins.recommended-parts.parts-placeholder' | translate }}"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.recommended-parts.other-parts' | translate }}</span>
              </h2>
            </td>
            <td class="margin">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.OtherParts"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input
                  type="number"
                  step="1"
                  min="0"
                  name="OtherParts"
                  class="ir-form-set"
                  formControlName="OtherParts"
                  placeholder="{{ 'plugins.recommended-parts.parts-placeholder' | translate }}"
                />
              </div>
            </td>
          </tr>

          <tr>
            <td class="margin">
              <h2>
                <span>{{ 'plugins.recommended-parts.currency' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.Currency"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <select name="Currency" class="ir-form-set" formControlName="Currency">
                  <option value="" disabled [selected]="!editForm.controls.Currency.value">
                    {{ 'plugins.recommended-parts.currency-placeholder' | translate }}
                  </option>
                  <option
                    *ngFor="let currency of currencies"
                    [value]="currency.value"
                    [selected]="editForm.controls.Currency.value === currency.value"
                  >
                    {{ currency.value | uppercase }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #deleteConfirm
  (confirmOutput)="deletePlugin($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<!--<modal (modalOutput)="selectCurrencyMenu($event)" (modalClosed)="onCurrencyMenuClose($event)" #CurrencyModal></modal>-->
